function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5489 4.6659L7.43474 7.10803C7.23332 7.162 7.06355 7.30108 6.96278 7.49468C6.862 7.68828 6.83848 7.92054 6.89738 8.14036L11.7833 26.3747C11.8422 26.5945 11.9787 26.7839 12.1627 26.9012C12.3468 27.0185 12.5634 27.054 12.7648 27.0001L26.4357 23.337C26.5354 23.3102 26.6284 23.2623 26.7094 23.196C26.7904 23.1297 26.8577 23.0462 26.9076 22.9503C26.9575 22.8545 26.989 22.7481 27.0002 22.6373C27.0114 22.5265 27.0022 22.4135 26.973 22.3046L23.4197 9.04328M16.5489 4.6659L23.4197 9.04328M16.5489 4.6659L18.1035 10.4677L23.4197 9.04328M14.1199 16.8652L20.1955 15.2373M15.0082 20.1805L21.0838 18.5526",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.8245 29.4136C31.0636 29.4136 33.6895 26.7877 33.6895 23.5486C33.6895 20.3094 31.0636 17.6836 27.8245 17.6836C24.5853 17.6836 21.9595 20.3094 21.9595 23.5486C21.9595 26.7877 24.5853 29.4136 27.8245 29.4136Z",
  fill: "#D2E490",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0889 23.6334L26.8579 25.4025C26.8579 25.4025 29.1179 23.1424 30.5661 21.6943",
  stroke: "#526C0C",
  strokeWidth: 0.796875,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgFileTextSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTextSuccess);
export default __webpack_public_path__ + "static/media/FileTextSuccess.04beea25.svg";
export { ForwardRef as ReactComponent };